
















































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CashflowV2 from '@/charts/CashFlow_v2.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';

@Component({
  components: {
    CashflowV2,
    DynamicColumnChart,
    DynamicLineChart,
    CashflowAnalysis,
  },
})

export default class CashflowAnalysis extends Vue {
  @Prop() readonly doc!: any;

  isActive(section: any) {
    const years = this.doc.cashflow.count;
    switch (section) {
      case 'recievedOwnerCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if (this.doc.cashflow.sheets[i].EquityWithoutNetProfitDelta + this.doc.cashflow.sheets[i].SubscribedCapitalUnpaidDelta > 0) {
            return true;
          }
        }
        return false;
      case 'hasMadeInvestments':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].InvestmentsCashflow !== 0) {
            return true;
          }
        }
        return false;
      case 'hasLoans':
        for (let i = 0; i <= years; i++) {
          if ((this.doc.balance.sheets[i].U + this.doc.balance.sheets[i].P) > 0) {
            return true;
          }
        }
        return false;
      case 'hasDividend':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].EquityWithoutNetProfitDelta < 0) {
            return true;
          }
        }
        return false;
      case 'hasError':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].CashFlowError !== 0) {
            return true;
          }
        }
        return false;
      case 'hasnot12months':
        for (let i = 0; i <= years; i++) {
          if (this.doc.balance.sheets[i].MONTHS !== '12') {
            return true;
          }
        }
        return false;
      case 'notCorrectWorkingCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if ( ((this.doc.balance.sheets[i].K - this.doc.balance.sheets[i].J - this.doc.balance.sheets[i].Q + this.doc.balance.sheets[i].U) - (this.doc.balance.sheets[i + 1].K - this.doc.balance.sheets[i + 1].J - this.doc.balance.sheets[i + 1].Q + this.doc.balance.sheets[i + 1].U)) + this.doc.cashflow.sheets[i].WorkingCaptialCashflow !== 0) {
            return true;
          }
        }
        return false;
      case 'almostCorrectWorkingCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if ( Math.abs(((this.doc.balance.sheets[i].K - this.doc.balance.sheets[i].J - this.doc.balance.sheets[i].Q + this.doc.balance.sheets[i].U) - (this.doc.balance.sheets[i + 1].K - this.doc.balance.sheets[i + 1].J - this.doc.balance.sheets[i + 1].Q + this.doc.balance.sheets[i + 1].U)) + this.doc.cashflow.sheets[i].WorkingCaptialCashflow) < 3) {
            return true;
          }
        }
        return false;
      case 'hasnotSameToDate':
        const toDate = this.doc.balance.sheets[0].DATE_TO.slice(5, 10);
        for (let i = 0; i <= years; i++) {
          if (this.doc.balance.sheets[i].DATE_TO.slice(5, 10) !== toDate) {
            return true;
          }
        }
        return false;
    }
  }

  thisVersion() {
  if (process.env.VUE_APP_BRAND === 'GT') {
    return 'gt';
  }
  }
}
